export default __webpack_public_path__ + "static/media/smiley4-open.b33513d7.svg";